import { TOGGLE_SIDEBAR } from './types';

export const toggleSidebar = () => {
  return {
    type: TOGGLE_SIDEBAR,
  };
};
